import { render, staticRenderFns } from "./ServiceSupport.vue?vue&type=template&id=1d5df67a&scoped=true&"
import script from "./ServiceSupport.vue?vue&type=script&lang=js&"
export * from "./ServiceSupport.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSupport.vue?vue&type=style&index=0&id=1d5df67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5df67a",
  null
  
)

export default component.exports